import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/sources/fleets/$id/alerts/no-data-alert/notification")({
  staticData: {
    title: "fleets.alerts.notification",
  },
});
